const { string, shape, number, arrayOf, bool } = require('prop-types');

const propTypes = {
  title: string,
  appId: string,
  selected: number,
  addresses: arrayOf(
    shape({
      address_id: number,
      label: string,
      receiver: string,
      enabled: bool,
      error_message: string,
      edit_action: shape({
        type: string,
        label: string,
        action: string,
      }),
    }),
  ),
  isFlow: bool.isRequired,
  lowEnd: bool.isRequired,
  goUrl: string,
  deviceType: string.isRequired,
  translations: shape({
    showMore: string.isRequired,
    showLess: string.isRequired,
    editAddresses: string.isRequired,
  }).isRequired,
  editAddressesURL: string.isRequired,
  shouldRenderExternalLinks: bool.isRequired,
  actions: shape({
    edit_address: shape({
      state: string,
    }),
  }),
};

const defaultProps = {
  addresses: [],
  selected: 0,
  goUrl: '',
  title: '',
  actions: {},
};

module.exports = { propTypes, defaultProps };
